/** @module components/visitors */


import {ChoiceQuiz, ChoiceQuizVisitor} from '../choice-quiz';
import {ClozeQuiz, ClozeQuizVisitor, SelectSpan} from '../cloze-quiz';
import {HotSpotQuiz, HotSpotQuizVisitor} from '../hot-spot-quiz';
import {QuizVisitor, canShowCorrectness} from '../quiz';


/**
 * Visitor that will set [[CanShowCorrectness.showCorrectness]] of all answers (choices) that are correct.
 *
 * ("Correct" here is to be understood not as "correctly answered by the user", but as "correct in principle".)
 *
 * @example
 *```typescript
 *
 * new ShowCorrectnessOfCorrectAnswersQuizVisitor().visit(quiz);
 *```
 */
export class ShowCorrectnessOfCorrectAnswersQuizVisitor extends QuizVisitor implements ChoiceQuizVisitor, ClozeQuizVisitor, HotSpotQuizVisitor {

    public visitChoiceQuiz(quiz: ChoiceQuiz): void {
        for (const choice of quiz.choices) {
            if (canShowCorrectness(choice)) {
                choice.showCorrectness = choice.correct;
            }
        }
    }

    public visitClozeQuiz(quiz: ClozeQuiz): void {
        for (const paragraph of quiz.paragraphs) {
            for (const span of paragraph.spans) {
                if (span instanceof SelectSpan) {
                    for (const choice of span.choices) {
                        if (canShowCorrectness(choice)) {
                            choice.showCorrectness = choice.correct;
                        }
                    }
                }
            }
        }
    }

    public visitHotSpotQuiz(quiz: HotSpotQuiz): void {
        for (const hotSpotArea of quiz.hotSpotAreas) {
            if (canShowCorrectness(hotSpotArea)) {
                hotSpotArea.showCorrectness = true;
            }
        }
    }
}
